import { css } from 'styled-components';
export const withPaddings = ({ padding, paddingTop, paddingRight, paddingBottom, paddingLeft, }) => {
    return css `
    ${padding && `padding: var(${padding});`}
    ${paddingTop && `padding-top: var(${paddingTop});`}
    ${paddingRight && `padding-right: var(${paddingRight});`}
    ${paddingBottom && `padding-bottom: var(${paddingBottom});`}
    ${paddingLeft && `padding-left: var(${paddingLeft});`}
  `;
};
